import type { ApolloCache } from '@apollo/client';

/**
 * Drops a paged field under every filter and sort it was read with, which is
 * what a cache-first list needs to read it fresh. Without an owner, the field is
 * a root query.
 */
export const evictConnectionField = (
  cache: ApolloCache<unknown>,
  fieldName: string,
  owner?: { __typename: string; id: string }
) => {
  cache.evict({ id: owner ? cache.identify(owner) : 'ROOT_QUERY', fieldName });
  cache.gc();
};
